import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {

  private API = environment.API

  constructor(private http: HttpClient) {
    environment.emitAPI.subscribe(api => {
      this.API = api
    })
  }

  getTabelaEmpresa(){
    return this.http.get<any>(`${this.API}TabelaPesquisa/EmpresaCliente`)
  }


  public fazPesquisaEmpresa(filtro, componente, campo, condicao?){

    const httpParams = new HttpParams({
      fromObject: {
        tabela: componente,
        coluna: campo,
        valor: filtro,
        condicaoPadrao: condicao
      }
    })

    return this.http.get<any>(`${this.API}TabelaPesquisa/GetPesquisa`, {params: httpParams})

  }
  public pesquisaEmpresaCliente(){
    return this.http.get<any>(`${this.API}TabelaPesquisa/VWEmpresaColaboradorResponsavelLegal`)
  }
}
